import axios from "axios";

const CONFIGURED_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

// Frontend and backend always share one host in this deployment, so talk to the
// origin the app was actually loaded from. That keeps the site working on the
// custom domain, the default deploy domain and preview with no rebuild.
function resolveBackendUrl() {
  if (typeof window === "undefined") return CONFIGURED_URL;
  const { origin, hostname } = window.location;
  if (hostname === "localhost" || hostname === "127.0.0.1") return CONFIGURED_URL || origin;
  return origin;
}

export const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

function readCookie(name) {
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : null;
}

const MUTATING = ["post", "put", "patch", "delete"];

// Attach Bearer token fallback + CSRF double-submit token.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("trex_token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // CSRF: echo the readable token cookie back in a header on state-changing
  // requests. Prefer the cookie (same-origin); fall back to the stored value
  // for split-domain deployments where the backend cookie isn't JS-readable.
  const method = (config.method || "get").toLowerCase();
  if (MUTATING.includes(method)) {
    const csrf = readCookie("trex_csrf") || localStorage.getItem("trex_csrf");
    if (csrf) config.headers["X-CSRF-Token"] = csrf;
  }
  return config;
});

export const mediaUrl = (mediaId) => `${API}/media/file/${mediaId}`;
